import moment from 'moment';

export const DEFAULT_AUTH_IDENTITY_SECRET = '14021997';

const getIdentitySecret = () =>
  process.env.REACT_APP_AUTH_IDENTITY_SECRET || DEFAULT_AUTH_IDENTITY_SECRET;

const randomSuffix = () => {
  const uuid = globalThis?.crypto?.randomUUID?.();
  if (uuid) {
    return uuid.split('-')[1];
  }
  return Math.random().toString(36).slice(2, 8);
};

const normalizeUsernamePrefix = value => {
  const normalized = (value || '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
  return normalized || 'user';
};

export const createLastActivityTimestamp = () => {
  return moment().format('YYYY-MM-DD HH:mm:ss');
};

export const generateUsername = firstName => {
  return `${normalizeUsernamePrefix(firstName)}${randomSuffix()}`;
};

export const encryptString = (plainText, secretKey = getIdentitySecret()) => {
  if (typeof plainText !== 'string' || plainText.length === 0) {
    return '';
  }

  const key = typeof secretKey === 'string' && secretKey.length > 0 ? secretKey : getIdentitySecret();
  let encryptedText = '';

  for (let i = 0; i < plainText.length; i += 1) {
    const plainCharCode = plainText.charCodeAt(i);
    const keyCharCode = key.charCodeAt(i % key.length);
    const encryptedCharCode = (plainCharCode + keyCharCode) % 256;
    encryptedText += String.fromCharCode(encryptedCharCode);
  }

  return encryptedText;
};


export const decryptString = (encryptedText, secretKey = getIdentitySecret()) => {
  if (typeof encryptedText !== 'string' || encryptedText.length === 0) {
    return '';
  }

  const key =
    typeof secretKey === 'string' && secretKey.length > 0
      ? secretKey
      : getIdentitySecret();

  let decryptedText = '';

  for (let i = 0; i < encryptedText.length; i += 1) {
    const encryptedCharCode = encryptedText.charCodeAt(i);
    const keyCharCode = key.charCodeAt(i % key.length);

    // reverse the encryption
    let decryptedCharCode = encryptedCharCode - keyCharCode;
    if (decryptedCharCode < 0) {
      decryptedCharCode += 256;
    }

    decryptedText += String.fromCharCode(decryptedCharCode);
  }

  return decryptedText;
};